import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import SectionTitle from '../Title';
import PostCard from '../PostCard';
import { useLanguage } from '../../i18n';
import { getBlogIndex } from '../../utils/content';
import './style.scss';

// Home-page teaser: the three latest articles.
const BlogArea = ({ className, title }) => {
    const [blogs, setBlogs] = useState(null);
    const { t, language } = useLanguage();

    useEffect(() => {
        // The index is newest-first.
        getBlogIndex().then((list) => setBlogs(list.slice(0, 3)));
    }, []);

    if (blogs && blogs.length === 0) return null;

    return (
        <section className={`blogTeaser ${className || ''}`}>
            <div className="container">
                {title && <SectionTitle title={t('blog.title')} subTitle={t('blog.subtitle')} />}

                <div className="blogTeaser__grid">
                    {blogs
                        ? blogs.map((blog) => <PostCard key={blog.slug} post={blog} />)
                        : [0, 1, 2].map((i) => <div key={i} className="blogTeaser__skeleton" />)}
                </div>

                <div className="blogTeaser__more">
                    <Link to="/blogs" className="blogTeaser__btn">
                        {language === 'hi' ? 'सभी लेख देखें' : 'View all articles'} <FaArrowRight aria-hidden="true" />
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default BlogArea;
